













































import Vue from 'vue'

export default Vue.extend({
    name: 'GameIntro',
    components: {},
    data: () => ({
        loading: {
            connection: false,
        },
    }),
    beforeDestroy() {
        document.removeEventListener('keypress', this.handleKey);
    },
    async mounted() {
        await this.$store.dispatch('initRandomFlags');
        document.addEventListener('keypress', this.handleKey, false);
    },
    methods: {
        handleKey(e: KeyboardEvent) {
            if (e.key === 'Enter') {
                this.newGame();
            }
        },
        async newGame() {
            this.loading.connection = true;
            try {
                await this.$store.dispatch('initializeSocket');
                await this.$store.dispatch('resetModel', {subsetId: null})
            } catch (e) {
                return;
            } finally {
                this.loading.connection = false;
            }
            if (!this.connected)
                return;
            await this.$router.push('/play');
        },
    },
    computed: {
        randomFlags() {
            return this.$store.state.randomFlags;
        },
        sessionDuration: {
            set(v: number) {
                this.$store.commit('sessionDuration', v);
            },
            get(): number {
                return this.$store.state.sessionDuration;
            }
        },
        countries: {
            set(v: number) {
                this.$store.commit('countries', v);
            },
            get(): number {
                return this.$store.state.countries;
            }
        },
        connected() {
            return this.$store.state.connected;
        },
    },
})
